<template>
  <div class="row" style="border-left: 0px solid">
    <div class="col-12 col-md-6 col-lg-6">
      <div v-for="company in foundCompanies">
        <div>
          <b>{{ company.name }}</b>
        </div>
        <a :href="company.url" target="_blank"
          ><b>{{ company.url }}</b></a
        >
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-6">
      <div v-if="deal.jdoc.amount">
        <span><b>Amount invested</b></span> {{ amountInvestedInDollars }}
      </div>
      <div v-if="deal.jdoc.year">
        <span><b>Year</b></span> {{ deal.jdoc.year }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "DealCard",
  props: ["deal"],
  computed: {
    ...mapGetters(["results", "companies"]),
    amountInvestedInDollars: function() {
      return (
        "$" +
        this.deal.jdoc.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      );
    },
    foundCompanies: function() {
      return this.companies.filter(item => {
        return this.deal.jdoc.investees.includes(item.id);
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/DealCard.vue